// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__xwSla","colCheckbox":"styles_colCheckbox__10_OJ"};